import React, { useState, useEffect } from "react";
import Dashboard from "./Components/Dashboard";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ComboChart from "./Components/Combochart";
import Histogram from "./Components/Histogram";
import AttendanceMultiple from "./Components/AttendanceMutiple";
import AttendanceSingleChart from "./Components/AttendanceSingleChart";
import Loader from "./Components/Loader";

const DashboardPage=()=>{

     useEffect(()=>{
                    document.title="Attendance Dashboard | Balaji Badminton Academy"
                  },[]);

    return(
        <>
        <Header/>
        <Loader/>
            {/* <Dashboard/>
            <ComboChart/>
            <Histogram/> */}
            <AttendanceMultiple/>
            <AttendanceSingleChart/>
        <Footer/>
        </>
    );
}

export default DashboardPage;